import React from 'react'
import { colors } from 'parameters'
import { FlexContainer, Heading, Paragraph } from 'components/styles'
import { ColorMods } from 'components/styles/primitives/modifiers/text/colorMods'
import { Tooltip } from 'components/elements/Tooltip'
import { SpaceProperties } from 'components/styles/definitions/size/typographyScale'

interface Props {
	sectionNumber: number
	title: string
	tooltipText?: string
}

export const SectionTitle: React.FC<React.PropsWithChildren<Props>> = ({ sectionNumber, title, tooltipText }) => {
	return (
		<FlexContainer justifyContent="start" alignItems="center" gap={SpaceProperties.Small}>
			<Paragraph big bold modifiers={ColorMods({ color: colors.primaryGreen1 })}>{`0${sectionNumber}`}</Paragraph>
			<Heading.H3>
				{title} {tooltipText && <Tooltip>{tooltipText}</Tooltip>}
			</Heading.H3>
		</FlexContainer>
	)
}
